import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { PetProfileImageUpload } from './ImageUpload/petProfileImageUpload';
import { PetCoverImageUpload } from './ImageUpload/petCoverImageUpload';
import { usePetImageUploadPopup } from './usePetImageUploadPopup';
import { PreloadWrapper } from '../preloadWrapper/preloadWrapper';

import './petProfileEditor.scss';

export const PetImageUploadPopup = ({
  handleClose,
  FullPolicyNumber,
  species,
  gender,
  profileImage,
  setPetProfileImage,
  coverImage,
  setCoverImage,
  petName
}) => {
  const {
    handleImageUpdates,
    updateIsLoading,
    iconCssClass,
    newProfileImage,
    setNewProfileImage,
    setCroppedPetImageAreaPixels,
    setProfileFileName,
    newCoverImage,
    setNewCoverImage,
    setCroppedCoverImageAreaPixels,
    setCoverFileName
  } = usePetImageUploadPopup(
    FullPolicyNumber,
    species,
    gender,
    profileImage,
    setPetProfileImage,
    coverImage,
    setCoverImage,
    handleClose
  );

  return (
    <Modal
      size="medium"
      open
      onClose={handleClose}
      customCssClass="petImageUploadDialog"
      footer={
        <div className="footerModalContainer">
          <button
            type="button"
            className="button primary outline"
            onClick={handleClose}
          >
            <span className="labelText">Cancel</span>
          </button>

          <button
            type="button"
            className="button primary"
            onClick={handleImageUpdates}
          >
            <span className="labelText">Update</span>
          </button>
        </div>
      }
    >
      <div className="petSureForm verticalStacked">
        <PreloadWrapper
          isLoading={updateIsLoading}
          customCssClass="custom-preload-wrapper"
        >
          <div className="petImageUpload">
            <section>
              <h4>Add a profile picture for {petName}</h4>
              <PetProfileImageUpload
                iconCssClass={iconCssClass}
                newProfileImage={newProfileImage}
                setNewProfileImage={setNewProfileImage}
                setCroppedPetImageAreaPixels={setCroppedPetImageAreaPixels}
                setProfileFileName={setProfileFileName}
              />
            </section>
            <section>
              <h4>Add a cover image for {petName}</h4>
              <PetCoverImageUpload
                newCoverImage={newCoverImage}
                setNewCoverImage={setNewCoverImage}
                setCroppedPetCoverAreaPixels={setCroppedCoverImageAreaPixels}
                setCoverFileName={setCoverFileName}
              />
            </section>
          </div>
        </PreloadWrapper>
      </div>
    </Modal>
  );
};

PetImageUploadPopup.propTypes = {
  handleClose: PropTypes.func,
  FullPolicyNumber: PropTypes.string,
  species: PropTypes.string,
  gender: PropTypes.string,
  profileImage: PropTypes.string,
  setPetProfileImage: PropTypes.func,
  coverImage: PropTypes.string,
  setCoverImage: PropTypes.func,
  petName: PropTypes.string
};
